<template>
  <div class="pie2-ctn" :style="ctnStyle">
    <div class="pie2-title">{{ title }}</div>
    <div class="pie2-contentCtn">
      <div :id="`wtpie2_${id}`" class="chart-ctn" :style="style">
      </div>
      <div class="chart-legendCtn">
        <div class="chart-oneLegend">
          <div class="chart-oneLegend_title">
            <div class="dot" :style="dotStyle1"></div><span>{{ $t('Bolus') }}</span>
          </div>
          <div class="chart-oneLegend_content">
            <span>{{ values[0] ? values[0]['value'] : '-' }} U</span><span class="chart-oneLegend_contentSplitLine"></span><span>{{ (values[0] ? values[0]['percent'] : '-') | numPretty }} %</span>
          </div>
        </div>
        <div class="chart-oneLegend">
          <div class="chart-oneLegend_title">
            <div class="dot" :style="dotStyle2"></div><span>{{ $t('Basal Rate') }}</span>
          </div>
          <div class="chart-oneLegend_content">
            <span>{{ values[1] ? values[1]['value'] : '-' }} U</span><span class="chart-oneLegend_contentSplitLine"></span><span>{{ (values[1] ? values[1]['percent'] : '-') | numPretty }} %</span>
          </div>
        </div>
      </div>
    </div>    
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'

import { derrorFactory, errorFactory, dlogFactory } from '@u/log'
const derror = derrorFactory('ChartPie2', false)
const error = errorFactory('ChartPie2', false)
const log = dlogFactory('ChartPie2', true)

let _id = 1
export default {
  name: 'CChartPie2',
  filters: {
    numPretty(str) {
      if (Number.isNaN(+str)) {
        return '-'
      } else {
        return str
      }
    }
  },
  mixins: [reDrawTrigger],
  props: {
    colors: {
      type: [Array],
      default: () => ['rgba(87, 181, 255, 1)', 'rgba(177, 220, 255, 1)']
    },
    values: {
      type: [Array],
      default: () => [{
        value: 30,
        name: 'Bolus'
      }, {
        value: 30,
        name: 'Basal Rate'
      }]
    },
    t2: {
      type: [String],
      default: ''
    },
    t1: {
      type: [String],
      default: `Total Insulin Usage`
    }
  },
  data() {
    _id++
    const id = `cpiev2_${+new Date()}_${_id}`
    return {
      id
    }
  },
  computed: {
    dotStyle1() {
      const { colors = [] } = this
      return { 'backgroundColor': colors[0] }
    },
    dotStyle2() {
      const { colors = [] } = this
      return { 'backgroundColor': colors[1] }
    },
    ctnStyle() {
      const { ctnH, ctnW, zoomRatio, stripeInnerBorderC, lfs } = this
      const rst = { width: ctnW + 'px', height: ctnH + 'px', zoom: zoomRatio }
      
      return rst
    },
    ctnH() {
      const { ctnW } = this
      return (281 / 359) * ctnW
    },
    ctnW() {
      const { ds } = this
      return (359 / 1754) * ds
    },
    h() {
      const { w } = this
      return w
    },
    w() {
      const ds = this.ds
      
      const r = 138 / 1754
      derror(`[pie2]computed ds: ${ds}, rst: ${r * ds}, r: ${r}`)
      return r * ds
    },
    style() {
      const { w, h, zoomRatio, stripeInnerBorderC, lfs } = this
      const rst = { width: w + 'px', height: h + 'px', zoom: zoomRatio }

      return rst
    },
    title() {
      const { values = [], t1, t2 } = this
      const msg = this.$t(t1)
      // const msg = this.$t(`Insulin injection in total`)
      const total = values.reduce((prev, cur) => {
        return (cur && cur.value !== undefined) ? (+cur.value + prev) : (prev)
      }, 0)
      /* eslint-disable */
      const part2 = t2 ? t2 : `(${_pretty(total.toFixed(1))} U)`
      /* eslint-enable */
      
      function _pretty(str) {
        if (/\.0/.test(str)) {
          return (+str).toFixed(0)
        }
        return str
      }
      return `${msg} ${part2}`
    }
  },
  mounted() {
    this.renderPies(false)
  },
  beforeDestroy() {
    try {
      if (this._myChart) {
        this._myChart.dispose() // 销毁echarts实例
        this._myChart = null
      }
    } catch (err) {
      error('被捕获:' + err)
    }
  },
  methods: {
    refreshTriggered() {
      derror(`CharPie ${this.id}, this.refreshTriggered`)
      this.renderPies(true)
    },
    renderPies(isUpdate = false) {
      // const { id } = this
      // const ds = this.ds
      if (!isUpdate) {
        this.initChart()
      } else {
        this.updateChart()
      }
    },
    getOpt(_val = []) {
      const { title, lfs } = this
      const values = _val.map(v => {
        return Object.assign({}, v, {
          name: this.$t(v.name)
        })
      })
      const ds = this.ds
      
      const o = {
        title: {
          padding: [(14 / 12) * lfs, 0, 0, (15 / 12 * lfs)],
          show: false,
          text: title,
          textStyle: {
            fontSize: lfs,
            color: 'black',
            fontWeight: 'bold'
          }
        },
        animation: false,
        tooltip: {
          show: false,
          trigger: 'item'
        },
        legend: {
          show: false
        },
        color: this.colors,
        series: [
          {
            name: 'Insulin injection',
            type: 'pie',
            radius: ['71%', '100%'],
            avoidLabelOverlap: false,
            // itemStyle: { // 会形成border、弧度
            //   borderRadius: 10,
            //   borderColor: '#fff',
            //   borderWidth: 2
            // },
            itemStyle: {
              borderRadius: 3
            },
            selectMode: true,
            selectedOffset: 5,
            showAbove: false,
            label: {
              normal: {
                show: false,
                fontSize: 12,
                position: 'outer', // 让labelLine末端对齐
                alignTo: 'labelLine', //
                distanceToLabelLine: 0,
                padding: [-20, 0, 0, 0],
                formatter: params => {
                  let p = params.percent.toFixed(0)
                  if (Number.isNaN(+params.percent)) {
                    p = '-'
                  }
                  return `{pre|${params.value}U  (${p + ' %'})}\n{name| ${params.name}}\n`
                },
                rich: {
                  pre: {
                    color: '#070C12',
                    fontFamily: 'PingFang-SC-Bold',
                    fontWeight: '700',
                    fontSize: 14,
                    align: 'left',
                  },
                  name: {
                    color: '#515669',
                    fontSize: 10,
                    padding: [5, 0, 5, -4],
                    align: 'left',
                  }
                }
              },
              emphasis: {
                show: false
              }
            },
            emphasis: {
              disabled: true,
              scaleSize: 3// ,
              // label: {
              //   show: true,
              //   fontSize: 40,
              //   fontWeight: 'bold'
              // }
            },
            labelLine: {
              show: false
            },
            labelLayout: (params) => {
              const isLeft = params.labelRect.x < ds / 2
              // points：labelLine的三个点坐标，改变第三个点的x坐标，增加length2的长度，达到label在labelLine线上
              const points = params.labelLinePoints
              if (isLeft) { // 左边
                points[2][0] = params.labelRect.x
              } else {
                points[2][0] = params.labelRect.x + params.labelRect.width
              }
              return {
                labelLinePoints: points
              }
            },
            data: values
          }
        ]
      }
      return o
    },
    initChart() {
      log(`initChart`)
      const { id } = this
      const canvasid = `wtpie2_${id}`
      try {
        const myChart = this.$echarts.init(document.getElementById(`${canvasid}`), null, { renderer: 'svg' })
        const opt = this.getOpt(this.values)
        
        myChart.setOption(opt)
        
        // 默认选中高亮
        const index = 0
        // myChart.dispatchAction({
        //   type: 'select',
        //   dataIndex: index
        // })
        // highlight后，才会显示标线这些,并且进行放大
        myChart.dispatchAction({
          type: 'highlight',
          dataIndex: 0
        })
        
        this._myChart = myChart
      } catch (err) {
        error('被捕获:' + err)
      }      
    },
    updateChart() {
      log(`updateChart, values: ${this.values}`)
      const myChart = this._myChart
      const newOpt = this.getOpt(this.values)
      this.$nextTick(() => {
        try {
          if (myChart) {
            myChart.setOption(newOpt)            
          }
        } catch (err) {
          error('被捕获:' + err)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixin';

$h: 40px;
.pie2-ctn {
    border-radius: 8px;
    border: 1px solid $colorEchartStripeInnerBorder;
    overflow: hidden;
    position: relative;
}
.pie2-title {
    @include heightMiddle($h);
    background: #E5F0EB;
    color: #000;
    font-weight: 500;
    font-weight: bold;
    text-indent: 20px;
}
.pie2-contentCtn {
    top: $h;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    @include flexRow(center, center);
    .chart-legendCtn {
        margin-left: 48px;
        .chart-oneLegend_title {
            /* color: rgba(23, 26, 29, 0.60); */
            color: #333;
            font-size: 18px;
            @include flexRow(flex-start, center);
            .dot {
                $d: 8px;
                height: $d;
                width: $d;
                border-radius: 50%;
                display: inline-block;
                margin-right: 4px;
            }
        }
        .chart-oneLegend_content {
            color: #333;
            font-size: 14px;
        }
        .chart-oneLegend_contentSplitLine {
            display: inline-block;
            width: 1px;
            /* background-color: $colorEchartStripeInnerBorder; */
            background-color: rgba(0, 0, 0, 0.5);
            height: 12px;
            position: relative;
            top: 1px;
            $w: 1em;
            margin-left: $w;
            margin-right: $w;
            margin-top: 4px;
        }
        .chart-oneLegend {
            &:last-child {
                margin-top: 29px;
            }
        }
    }
}
.chart-ctn {
    display: inline-block;
    @include bBox;
}
</style>
